import type { Component } from "svelte";

export type ComponentOrModule<C extends Component> = C | { default: C };

export const getComponent = <C extends Component>(componentOrModule: ComponentOrModule<C>): C => {
  return "default" in componentOrModule ? componentOrModule.default : componentOrModule;
};

export const resolveComponent = <C extends Component>(
  component: () => ComponentOrModule<C> | Promise<ComponentOrModule<C>>,
): Promise<C> | C => {
  const componentOrPromise = component();

  if (Promise.resolve(componentOrPromise) === componentOrPromise) {
    return componentOrPromise.then(getComponent);
  } else {
    return getComponent(componentOrPromise as ComponentOrModule<C>);
  }
};
